import clsx from "clsx";
import { forwardRef, useEffect, useState } from "react";

import Icon from "~/components/Icon";
import { InputNumber, InputNumberValueChangeEvent } from "primereact/inputnumber";

interface Props {
  className?: string;
  inputClassName?: string;
  name: string;
  value?: number | null;
  defaultValue?: number | null;
  placeholder?: string;
  min?: number;
  max?: number;
  maxFractionDigits?: number;
  step?: number;
  ariaLabel?: string;
  autoFocus?: boolean;
  isInvalid?: boolean;
  onChange?: (value: string) => void;
  withIcon?: boolean;
}

const NumberInput = forwardRef<HTMLInputElement, Props>((
    {
      className = null,
      name,
      value = 0,
      defaultValue = null,
      min = undefined,
      max = undefined,
      step = undefined,
      placeholder = "",
      autoFocus = undefined,
      ariaLabel = undefined,
      isInvalid = false,
      maxFractionDigits = 3,
      onChange = () => {},
      withIcon = false
    }, ref) => {
    if (name.length === 0) {
      throw new Error("Empty input name");
    }

    const [state, setState] = useState<string>(String(value ?? (defaultValue ?? 0)));

    useEffect(() => {
      onChange(state);
    }, [state]);

    useEffect(() => {
      setState(String(value));
    }, [value]);

    const icon = (
      <span className="absolute h-full p-3">
        <Icon v="keypad" />
      </span>
    );

    return (
      <div className={clsx(
        "relative flex items-center w-full",
        className
      )}>
        {withIcon ? icon : null}

        <InputNumber
          value={Number(state)}
          name={name}
          inputId={name}
          onChange={(e) => {
            if (e.value == null) {
              setState('0');
              // onChange('0');
              return;
            }
            if (isNaN(e.value)) {
              return;
            }
            setState(String(e.value));
            // onChange(String(e.value));
          }}
          showButtons
          {...(step !== undefined ? { step } : {})}
          mode="decimal"
          unstyled
          min={min}
          max={max}
          maxFractionDigits={maxFractionDigits}
          placeholder={placeholder}
          aria-label={ariaLabel}
          autoFocus={autoFocus}
          {...(ref ? { inputRef: ref } : {})}
          pt={{
            root: { className: "inputnumber" + (withIcon ? " with-icon" : '') },
            buttonGroup: { className: "flex flex-col" },
            incrementButton: { className: "inputnumber-inc" },
            decrementButton: { className: "inputnumber-dec" },
          }}
        />
      </div>
    );
  }
);
export default NumberInput;